module.exports = __webpack_public_path__ + "static/media/chris-karidisz.141e54b5.jpg";